<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M11.17 21q-.82 0-1.56-.34-.74-.33-1.22-.98L3.66 13.4l.26-.3q.25-.27.6-.33.33-.06.65.12l3.02 1.5V6.76q0-.21.15-.36t.35-.14a.5.5 0 0 1 .5.5v9.32l-3.57-1.77 3.64 4.8q.33.45.85.66.5.22 1.06.22h4.31q1.05 0 1.79-.72A2.4 2.4 0 0 0 18 17.5v-3.54q0-.6-.4-1.01-.42-.42-1.02-.41h-4.61v-1h4.6q1.02 0 1.72.7.7.72.71 1.72v3.54q0 1.46-1.03 2.48A3.4 3.4 0 0 1 15.48 21zM5.23 8.77a4 4 0 0 1-.54-2q0-1.67 1.17-2.84a3.9 3.9 0 0 1 2.83-1.16q1.67 0 2.84 1.16a3.9 3.9 0 0 1 1.16 2.84 4 4 0 0 1-.54 2l-.86-.5a3 3 0 0 0 .4-1.5q0-1.24-.87-2.13a3 3 0 0 0-2.13-.87q-1.25 0-2.12.87a3 3 0 0 0-.88 2.13 3 3 0 0 0 .4 1.5z"
      />
    </svg>
  </span>
</template>
